import script from "./DesktopPause.vue?vue&type=script&lang=ts&setup=true"
export * from "./DesktopPause.vue?vue&type=script&lang=ts&setup=true"

import "./DesktopPause.vue?vue&type=style&index=0&id=cd47712e&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src462465770/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd47712e"]])

export default __exports__